import { Alert, AlertTitle, Button, Stack, Typography } from "@mui/material";
import { Info, CheckCircle, Warning, Error } from "@mui/icons-material";
import React from "react";
import { AlertDescription } from "@chakra-ui/react";

interface NoticeProps {
  status: "fail" | "warning" | "success" | "info";
  title: string;
  subtitle?: string;
  description: string;
  buttonTitle?: string;
  action?: () => void;
  sx?: object;
}

const statusMap: Record<NoticeProps['status'], { severity: "error" | "warning" | "success" | "info"; bgColor: string; icon: JSX.Element }> = {
  fail: { severity: "error", bgColor: "#d32f2f", icon: <Error sx={{ fontSize: 40, color: "#fff" }} /> }, 
  warning: { severity: "warning", bgColor: "#f57c00", icon: <Warning sx={{ fontSize: 40, color: "#fff" }} /> },
  success: { severity: "success", bgColor: "#388e3c", icon: <CheckCircle sx={{ fontSize: 40, color: "#fff" }} /> }, 
  info: { severity: "info", bgColor: "#1976d2", icon: <Info sx={{ fontSize: 40, color: "#fff" }} /> }, 
};

const Notice: React.FC<NoticeProps> = ({ status, title, subtitle, description, buttonTitle, action, sx }) => {
  return (
    <Alert
      severity={statusMap[status].severity}
      icon={statusMap[status].icon}
      sx={{ backgroundColor: statusMap[status].bgColor, color: "#fff", ...sx }}
    >
      <Stack spacing={1}>
      <Typography fontSize='19px' fontWeight={600}> {title}</Typography>
        {subtitle && <Typography fontSize='12px' marginTop='-10px'>{subtitle}</Typography>}
        <Typography fontSize='16px' fontWeight={600}> {description}</Typography>
       
        {buttonTitle && action && (
          <Button variant="contained" sx={{ backgroundColor: "#fff", color: statusMap[status].bgColor }} onClick={action}>
            {buttonTitle}
          </Button>
        )}
      </Stack>
    </Alert>
  );
};

export default Notice;
